<template>
  <v-app>
    <ns-header />
    <div class="app-wrapper">
        <v-content class="app-content" v-if="sponsorId">
            <invite-link-builder
                :market="userLocale.country"
                :language="userLocale.language"
                :user-id="sponsorId"
            />
        </v-content>
    </div>
    <ns-footer />
  </v-app>
</template>

<script>
import {VApp, VContent} from 'vuetify/lib';
import {NsHeader, NsFooter} from '@nuskin/app-components';

import {RunConfigService} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';

import {InviteLinkBuilder} from '@nuskin/account-components';
import {getEnv} from '../config/appEnv';

export default {
    name: 'App',
    components: {
        NsHeader,
        NsFooter,
        VApp,
        VContent,
        InviteLinkBuilder
    },
    data() {
        const runConfig = RunConfigService.getRunConfig();
        const userLocale = {
            country: runConfig.country,
            language: runConfig.language
        };

        const user = UserService.getUser();
        const sponsorId = user?.id;

        return {
            userLocale,
            sponsorId
        };
    },
    async mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('$disableRedirect') == null &&
            !UserService.isLoggedIn()) {
            // Redirect to login page.
            const runConfig = RunConfigService.getRunConfig();
            const env = getEnv();
            const cancelPage = runConfig.baseUrl || env.baseUrl;
            const destinationPage = window.location.href;
            const params = new URLSearchParams(window.location.search);
            const locale = params.get('locale');
            let language = 'en';
            let country = 'US';
            if (locale) {
                [language, country] = locale.split('_');
            }
            const url = `${runConfig.baseUrl || env.baseUrl}/content/login/corporate/${
                runConfig.language || language}.html?cancel=${
                cancelPage}&destination=${destinationPage}&market=${
                runConfig.country || country}`;

            console.debug(`Redirecting to ${url}`);
            window.location = url;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@nuskin/ns-core-styles/src/scss/_global.mixins.scss';
@import '~@/styles/variables.scss';

$app-max-width: 600px;

.app-wrapper {
    background-color: #F7F7F7;
    height: 100%;
    width: 100%;
    padding: 16px;
    font-size: 16px;
    ::v-deep input { // The header/footer bring in bad styles
        border: 0;
        box-shadow: none !important;
    }
}
.app-content {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: $app-max-width;
}
</style>
